// Shared with Spotlight NextGen (same origin via the Vercel rewrite) so the sidebar stays
// collapsed/expanded when navigating between Legacy and NextGen. Keep the key in sync with
// d2c-admin-tools' apps/spotlight-ui/app/shared/components/SideNav/collapsed-storage.ts.
const sidebarCollapsedStorageKey = 'spotlight_sidebar_collapsed';

export function readSidebarCollapsed(): boolean {
  try {
    return localStorage.getItem(sidebarCollapsedStorageKey) === 'true';
  } catch {
    return false;
  }
}

export function writeSidebarCollapsed(isCollapsed: boolean): void {
  try {
    localStorage.setItem(sidebarCollapsedStorageKey, String(isCollapsed));
  } catch {
    // Ignore storage failures; the toggle still works for this page.
  }
}
